/* AthleteSwap — Produktgalerie: Miniaturen, Bühne mit Klick-Vollbild,
   Tastatur-/Wisch-Navigation. Verhalten 1:1 portiert aus
   components/ProduktGalerie.tsx, hier als eigenständiges Custom-Element
   ohne Framework-Abhängigkeit. Bilder kommen aus einem JSON-Array im
   data-as-bilder-Attribut ([{src, alt}, ...]) statt aus React-State. */
(function () {
  var WISCH_SCHWELLE = 40;

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      var args = arguments;
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  }

  function AsGalerie(root) {
    this.root = root;
    this.index = 0;
    this.stageImg = root.querySelector('[data-as-galerie-bild]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-as-galerie-thumb]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-as-galerie-punkt]'));
    this.stage = root.querySelector('[data-as-galerie-stage]');
    this.spalte = root.querySelector('.as-produkt-galerie-spalte');
    this.miniaturen = root.querySelector('.as-produkt-galerie-miniaturen');
    this.zurueckBtn = root.querySelector('[data-as-galerie-zurueck]');
    this.vorBtn = root.querySelector('[data-as-galerie-vor]');
    this.zaehler = root.querySelector('[data-as-galerie-zaehler]');
    this.lightbox = null;
    this.startX = null;

    this.bilder = this.thumbs.map(function (thumb) {
      return { src: thumb.getAttribute('data-full'), alt: thumb.getAttribute('data-alt') || '' };
    });
    if (this.bilder.length === 0 && this.stageImg) {
      this.bilder = [{ src: this.stageImg.getAttribute('src'), alt: this.stageImg.getAttribute('alt') || '' }];
    }
    if (this.bilder.length === 0) return;

    var self = this;

    /* Miniaturspalte endet auf Höhe der Bühnenspalte (Bühne + Punkte),
       statt bei 15-20 Bildern beliebig weit zu wachsen. Die Bühne ist per
       aspect-ratio breitenabhängig, deshalb bei Resize neu messen. */
    if (this.spalte && this.miniaturen) {
      this.hoeheSynchronisieren();
      window.addEventListener('resize', debounce(function () {
        self.hoeheSynchronisieren();
      }, 150));
    }
    this.thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        self.gehZu(i);
      });
    });
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.gehZu(i);
      });
    });

    if (this.stage) {
      this.stage.addEventListener('click', function () {
        self.oeffneVollbild();
      });
      this.stage.addEventListener('touchstart', function (e) {
        self.startX = e.touches[0].clientX;
      });
      this.stage.addEventListener('touchend', function (e) {
        self.beruehrungsEnde(e);
      });
    }

    /* stopPropagation, damit ein Klick auf den Pfeil nicht zusätzlich den
       Stage-Klick (Vollbild öffnen) auslöst. */
    if (this.zurueckBtn) {
      this.zurueckBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        self.blaettern(-1);
      });
    }
    if (this.vorBtn) {
      this.vorBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        self.blaettern(1);
      });
    }
  }

  AsGalerie.prototype.hoeheSynchronisieren = function () {
    var hoehe = this.spalte.getBoundingClientRect().height;
    if (hoehe > 0) this.miniaturen.style.maxHeight = hoehe + 'px';
  };

  AsGalerie.prototype.gehZu = function (i) {
    this.index = (i + this.bilder.length) % this.bilder.length;
    var bild = this.bilder[this.index];
    if (this.stageImg && bild) {
      /* Shopifys image_tag-Filter erzeugt für das Bühnenbild automatisch
         srcset+sizes (obwohl im Liquid kein "widths:" angegeben ist).
         Ein Browser wählt bei vorhandenem srcset bevorzugt daraus aus,
         auch nachdem .src per JS neu gesetzt wurde — das alte srcset bleibt
         sonst aktiv und das Bild wechselt unzuverlässig (bestätigt über
         img.currentSrc, siehe Session-Verifikation). srcset/sizes werden
         deshalb vor dem Wechsel entfernt, damit .src wieder die einzige,
         eindeutige Quelle ist. */
      this.stageImg.removeAttribute('srcset');
      this.stageImg.removeAttribute('sizes');
      this.stageImg.src = bild.src;
      this.stageImg.alt = bild.alt || '';
    }
    this.thumbs.forEach(function (thumb, j) {
      var aktiv = j === this.index;
      thumb.classList.toggle('as-produkt-galerie-miniatur-aktiv', aktiv);
      if (aktiv && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest' });
    }, this);
    this.dots.forEach(function (dot, j) {
      dot.classList.toggle('as-produkt-galerie-punkt-aktiv', j === this.index);
    }, this);
    if (this.zaehler) this.zaehler.textContent = this.index + 1 + ' / ' + this.bilder.length;
    if (this.lightbox) this.aktualisiereVollbild();
  };

  AsGalerie.prototype.blaettern = function (richtung) {
    this.gehZu(this.index + richtung);
  };

  AsGalerie.prototype.beruehrungsEnde = function (e) {
    if (this.startX === null || this.bilder.length < 2) return;
    var strecke = e.changedTouches[0].clientX - this.startX;
    if (Math.abs(strecke) > WISCH_SCHWELLE) this.blaettern(strecke < 0 ? 1 : -1);
    this.startX = null;
  };

  AsGalerie.prototype.oeffneVollbild = function () {
    if (!this.lightbox) this.baueVollbild();
    this.lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    this.aktualisiereVollbild();
    var self = this;
    this._onKey = function (e) {
      if (e.key === 'Escape') self.schliesseVollbild();
      if (e.key === 'ArrowRight') self.blaettern(1);
      if (e.key === 'ArrowLeft') self.blaettern(-1);
    };
    window.addEventListener('keydown', this._onKey);
  };

  AsGalerie.prototype.schliesseVollbild = function () {
    if (!this.lightbox) return;
    this.lightbox.hidden = true;
    document.body.style.overflow = '';
    if (this._onKey) window.removeEventListener('keydown', this._onKey);
  };

  AsGalerie.prototype.aktualisiereVollbild = function () {
    if (!this.lightbox) return;
    var bild = this.bilder[this.index];
    var img = this.lightbox.querySelector('[data-as-vollbild-bild]');
    var zaehler = this.lightbox.querySelector('[data-as-vollbild-zaehler]');
    if (img && bild) {
      img.src = bild.src;
      img.alt = bild.alt || '';
    }
    if (zaehler) zaehler.textContent = this.index + 1 + ' / ' + this.bilder.length;
  };

  AsGalerie.prototype.baueVollbild = function () {
    var self = this;
    var overlay = document.createElement('div');
    overlay.className = 'as-produkt-vollbild';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;

    var kopf = document.createElement('div');
    kopf.className = 'as-produkt-vollbild-kopf';
    var zaehler = document.createElement('span');
    zaehler.setAttribute('data-as-vollbild-zaehler', '');
    var schliessen = document.createElement('button');
    schliessen.type = 'button';
    schliessen.textContent = 'Schließen';
    schliessen.addEventListener('click', function () {
      self.schliesseVollbild();
    });
    kopf.appendChild(zaehler);
    kopf.appendChild(schliessen);

    var buehne = document.createElement('div');
    buehne.className = 'as-produkt-vollbild-buehne';
    buehne.addEventListener('touchstart', function (e) {
      self.startX = e.touches[0].clientX;
    });
    buehne.addEventListener('touchend', function (e) {
      self.beruehrungsEnde(e);
    });

    var img = document.createElement('img');
    img.setAttribute('data-as-vollbild-bild', '');
    buehne.appendChild(img);

    if (this.bilder.length > 1) {
      var links = document.createElement('button');
      links.type = 'button';
      links.className = 'as-produkt-vollbild-blaettern as-produkt-vollbild-links';
      links.setAttribute('aria-label', 'Vorheriges Bild');
      links.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5 8 12l7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      links.addEventListener('click', function () {
        self.blaettern(-1);
      });

      var rechts = document.createElement('button');
      rechts.type = 'button';
      rechts.className = 'as-produkt-vollbild-blaettern as-produkt-vollbild-rechts';
      rechts.setAttribute('aria-label', 'Nächstes Bild');
      rechts.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 5 7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      rechts.addEventListener('click', function () {
        self.blaettern(1);
      });

      buehne.appendChild(links);
      buehne.appendChild(rechts);
    }

    overlay.appendChild(kopf);
    overlay.appendChild(buehne);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) self.schliesseVollbild();
    });

    document.body.appendChild(overlay);
    this.lightbox = overlay;
  };

  /* Favorit-Button.
     - Ausgeloggt: NIE einen Favoriten vortäuschen — stattdessen direkt zum
       nativen Shopify-Login mit return_url zurück auf diese Produktseite.
       Shopify bringt den Nutzer nach erfolgreichem Login/Registrieren damit
       von selbst hierher zurück, kein eigenes Modal/Redirect-Handling nötig.
     - Eingeloggt: wird lokal im Browser gemerkt. Eine wirklich kontogebundene,
       geräteübergreifende Speicherung (Customer-Metafield/-Account-API)
       braucht eine eigene Shopify-App bzw. Customer-Account-Extension — das
       lässt sich nicht rein aus dem Theme heraus schreiben (mit dem Kunden
       besprochen, noch nicht gebaut). Der lokale Stand ist bewusst je
       Kunden-ID getrennt, damit nach einem Logout/Login-Wechsel auf demselben
       Gerät keine fremden Favoriten angezeigt werden. */
  function favoritenSchluessel(btn) {
    var kundenId = btn.getAttribute('data-kunden-id') || 'gast';
    return 'as_favoriten_v1_' + kundenId;
  }

  function favoritenLesen(schluessel) {
    try {
      return JSON.parse(window.localStorage.getItem(schluessel)) || [];
    } catch (e) {
      return [];
    }
  }

  function favoritenSchreiben(schluessel, liste) {
    try {
      window.localStorage.setItem(schluessel, JSON.stringify(liste));
    } catch (e) {
      /* localStorage nicht verfügbar (z. B. privater Modus) — Button bleibt bedienbar, merkt sich nur nichts */
    }
  }

  function favoritInit(btn) {
    var eingeloggt = btn.getAttribute('data-logged-in') === 'true';

    if (!eingeloggt) {
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () {
        window.location.href = btn.getAttribute('data-login-url');
      });
      return;
    }

    var id = btn.getAttribute('data-produkt-id');
    var schluessel = favoritenSchluessel(btn);
    var aktiv = favoritenLesen(schluessel).indexOf(id) !== -1;
    btn.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
    btn.addEventListener('click', function () {
      var liste = favoritenLesen(schluessel);
      var index = liste.indexOf(id);
      if (index === -1) {
        liste.push(id);
      } else {
        liste.splice(index, 1);
      }
      favoritenSchreiben(schluessel, liste);
      btn.setAttribute('aria-pressed', index === -1 ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('[data-as-galerie]:not([data-as-galerie-init])').forEach(function (root) {
      root.setAttribute('data-as-galerie-init', '');
      new AsGalerie(root);
    });
    document.querySelectorAll('[data-as-favorit]:not([data-as-favorit-init])').forEach(function (btn) {
      btn.setAttribute('data-as-favorit-init', '');
      favoritInit(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
